import type { Opportunity, UserRole } from '../types';

/** Maps a user role to the opportunity types that are relevant for that role. */
export const ROLE_TYPE_MAP: Partial<Record<UserRole, Opportunity['type'][]>> = {
    'Musician':                    ['Gig', 'Jam Session', 'Musician Needed', 'Audition', 'Open Mic', 'Live Show', 'Showcase', 'Workshop'],
    'Singer':                      ['Gig', 'Jam Session', 'Musician Needed', 'Audition', 'Open Mic', 'Live Show', 'Showcase', 'Workshop'],
    'DJ':                          ['DJ Needed', 'DJ set', 'Event', 'Gig'],
    'Actor':                       ['Audition', 'Movie', 'Short Movie', 'TV Show', 'Stage Play', 'Workshop', 'Presentation'],
    'Director':                    ['Movie', 'Short Movie', 'TV Show'],
    'Dancer':                      ['Audition', 'Stage Play', 'Movie', 'Event', 'Showcase', 'Workshop'],
    'Performer':                   ['Gig', 'Live Show', 'Event', 'Stage Play', 'Showcase'],
    'Choreographer':               ['Audition', 'Stage Play', 'Movie', 'Workshop'],
    'Model':                       ['Audition', 'Movie', 'Short Movie', 'TV Show'],
    'Comedian':                    ['Stand Up Comedy', 'Open Mic', 'Event', 'Workshop'],
    'Writer':                      ['Workshop', 'Presentation', 'Event', 'Job'],
    'Painter':                     ['Workshop', 'Vernissage', 'Collective Exhibition', 'Event', 'Job'],
    'Visual Artist':               ['Workshop', 'Vernissage', 'Collective Exhibition', 'Presentation', 'Event', 'Job'],
    'Venue':                       ['Event', 'Live Show', 'Gig', 'Workshop'],
    'Live Club':                   ['Event', 'Live Show', 'Gig', 'Workshop'],
    'Theatre':                     ['Stage Play', 'Audition'],
    'Cinema':                      ['Movie', 'Short Movie'],
    'Festival':                    ['Event', 'Gig', 'Live Show', 'Workshop'],
    'Label':                       ['Job', 'Audition'],
    'Producer':                    ['Job', 'Gig', 'Event'],
    'Sound Engineer':              ['Job', 'Gig', 'Event'],
    'Recording Studio':            ['Job'],
    'Music Store':                 ['Job'],
    'Luthier':                     ['Job'],
    'Graphic Designer':            ['Job'],
    'Vocal Coach':                 ['Job', 'Workshop'],
    'Music School':                ['Job', 'Workshop'],
    'Acting Academy':              ['Job', 'Workshop'],
    'Dance School':                ['Job', 'Workshop'],
    'Casting Agency':              ['Audition', 'Movie', 'TV Show', 'Stage Play'],
    'Event Agency':                ['Event', 'Gig', 'Live Show', 'Workshop'],
    'Filmmaker / Videographer':    ['Movie', 'Short Movie', 'TV Show', 'Job'],
    'Photographer':                ['Job', 'Event', 'Vernissage', 'Collective Exhibition'],
    'Light Designer':              ['Job', 'Event', 'Gig'],
    'Make-Up Artist (MUA)':        ['Job', 'Movie', 'Short Movie', 'TV Show', 'Stage Play'],
    'Costume Designer / Stylist':  ['Job', 'Movie', 'Short Movie', 'TV Show', 'Stage Play'],
    'Backline Rental':             ['Job', 'Gig', 'Event'],
};

/** Returns true if the opportunity's date has already passed. Undated posts never expire. */
export const isPast = (opp: Opportunity): boolean => {
    if (!opp.startDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const end = opp.endDate
        ? new Date(`${opp.endDate}T23:59:59`)
        : new Date(`${opp.startDate}T23:59:59`);
    return end < today;
};
